/* eslint-disable max-len */
import React, { FC } from 'react'
import { Callback } from 'Pages/landings/common/types'

interface ComponentProps {
	onClose: Callback
}

export const MobileMenuComponent: FC<ComponentProps> = ({ children, onClose }) => {
	return (
		<div className="landing-menu-drawer-wrapper">
			<div className="landing-menu-drawer">
				<div className="landing-menu-drawer__close-icon" onClick={onClose}>
					<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
						<path d="M5.28935 5.29246C4.90355 5.6824 4.90355 6.31463 5.28935 6.70457L10.6029 12.0753L5.43828 17.2954C5.05248 17.6854 5.05248 18.3176 5.43828 18.7075C5.82408 19.0975 6.44958 19.0975 6.83537 18.7075L12 13.4874L17.1646 18.7075C17.5504 19.0975 18.1759 19.0975 18.5617 18.7075C18.9475 18.3176 18.9475 17.6854 18.5617 17.2954L13.3971 12.0753L18.7107 6.70457C19.0964 6.31463 19.0964 5.6824 18.7107 5.29246C18.3249 4.90251 17.6994 4.90251 17.3136 5.29246L12 10.6632L6.68644 5.29246C6.30064 4.90251 5.67514 4.90251 5.28935 5.29246Z" />
					</svg>
				</div>
				{children}
			</div>
		</div>
	)
}
